import type { RequestPayload } from "@inertiajs/core";
import { router, usePage } from "@inertiajs/react";
import { Button, Container, Flex, Paper, PasswordInput, Stack, Title } from "@mantine/core";
import { useForm } from "@mantine/form";
import { user_password_path } from "../../routes";

type PasswordResetProps = {
  token: string;
};

type FormErrors = {
  password: string[];
  password_confirmation: string[];
};

export default function PasswordReset({ token }: PasswordResetProps) {
  const { errors } = usePage<{ errors: FormErrors }>().props;

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      user: {
        reset_password_token: token,
        password: "",
        password_confirmation: "",
      },
    },
  });

  const onSubmit = (values: RequestPayload) => router.put(user_password_path(), values);

  return (
    <Container fluid mt="4rem">
      <Flex justify="center" align="center">
        <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
          <Paper shadow="sm" p="lg" withBorder w="40rem" maw="40rem">
            <Stack>
              <Title order={2}>Passwort ändern</Title>
              <PasswordInput
                label="Passwort"
                key={form.key("user.password")}
                {...form.getInputProps("user.password")}
                error={errors?.password}
              />
              <PasswordInput
                label="Passwort bestätigen"
                key={form.key("user.password_confirmation")}
                {...form.getInputProps("user.password_confirmation")}
                error={errors?.password_confirmation}
              />
              <Button type="submit">Passwort ändern</Button>
            </Stack>
          </Paper>
        </form>
      </Flex>
    </Container>
  );
}
